import { render, staticRenderFns } from "./VCadastroAlerta.vue?vue&type=template&id=652ac1b9&scoped=true&"
import script from "./VCadastroAlerta.vue?vue&type=script&lang=js&"
export * from "./VCadastroAlerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ac1b9",
  null
  
)

export default component.exports